export const MAP_MARKERS = {
  self: '#ffffff', npc: '#d8b56a', enemy: '#dc7970', adventurer: '#9fcca6', portal: '#ab92d5', fallen: '#525560',
} as const;
/** Network NPC collection also contains enemies. Keep their map identities distinct. */
export function npcMapMarker(entity: { isNpc?: boolean; health?: number }) {
  return entity.isNpc ? { type: 'npc' as const, color: MAP_MARKERS.npc }
    : { type: 'mob' as const, color: (entity.health ?? 0) > 0 ? MAP_MARKERS.enemy : MAP_MARKERS.fallen };
}
